import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addBanner } from 'slice/bannerSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Add = () => {
    const [formData, setFormData] = useState({
        title: '',
        image: null
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.banner);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setFormData(prev => ({ ...prev, image: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.image) {
            toast.error('Image is required');
            return;
        }

        const data = new FormData();
        data.append('title', formData.title);
        data.append('image', formData.image);

        dispatch(addBanner(data));
        toast.success("Adding banner...");
        setTimeout(() => navigate('/khajuraho/banners'), 1500);
    };

    return (
        <div className="container-fluid mt-5 pb-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add Banner</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-12 mt-2">
                        <label htmlFor="title" className="adminlables">Banner Title (Optional)</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={formData.title}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="image" className="adminlables">Banner Image</label>
                        <input
                            type="file"
                            id="image"
                            name="image"
                            className="form-control btn-block filebg"
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Adding...' : 'Add Banner'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Add;
